/**
 * DiscoveryPage Component
 * Main discovery page with tabbed navigation
 */
import React, { useState } from 'react';
import { Container, Nav } from 'react-bootstrap';
import { Compass, Calendar, Map } from 'lucide-react';
import { RecommendedTab } from './tabs/RecommendedTab';
import { SeasonalTab } from './tabs/SeasonalTab';
import { RoutesTab } from './tabs/RoutesTab';
import './DiscoveryPage.css';

type TabKey = 'recommended' | 'seasonal' | 'routes';

export const DiscoveryPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>('recommended');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'recommended':
        return <RecommendedTab />;
      case 'seasonal':
        return <SeasonalTab />;
      case 'routes':
        return <RoutesTab />;
      default:
        return null;
    }
  };

  return (
    <div className='discovery-page'>
      <div className='discovery-page-hero'>
        <Container>
          <div className='discovery-page-hero-content'>
            <h1 className='discovery-page-title'>
              <Compass size={40} />
              Discover Your Next Adventure
            </h1>
            <p className='discovery-page-subtitle'>
              Explore personalized trip recommendations, seasonal destinations,
              and exciting routes
            </p>
          </div>
        </Container>
      </div>

      <Container>
        <Nav
          variant='tabs'
          className='discovery-page-tabs'
          activeKey={activeTab}
        >
          <Nav.Item>
            <Nav.Link
              eventKey='recommended'
              onClick={() => setActiveTab('recommended')}
              className={activeTab === 'recommended' ? 'active' : ''}
            >
              <Compass size={20} />
              <span>Recommended</span>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey='seasonal'
              onClick={() => setActiveTab('seasonal')}
              className={activeTab === 'seasonal' ? 'active' : ''}
            >
              <Calendar size={20} />
              <span>Seasonal</span>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey='routes'
              onClick={() => setActiveTab('routes')}
              className={activeTab === 'routes' ? 'active' : ''}
            >
              <Map size={20} />
              <span>Routes</span>
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <div className='discovery-page-content'>{renderTabContent()}</div>
      </Container>
    </div>
  );
};
